import { Component, Mixins, Prop, VModel } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import TranslationJobModel from '@/views/Language/models/translationJob'
import StringGroupModel from '@/views/Language/models/stringGroup'

@Component({})
export default class TranslationJob extends Mixins<MixinInterface>() {
    @VModel() translationJob!: TranslationJobModel
    @Prop() translationJobs!: Array<TranslationJobModel>
    @Prop() stringGroups!: Array<StringGroupModel>

    // DELETE
    deleting = false
    async toggleDelete() {
        this.deleting = true
        await this.translationJob.delete()
        this.deleting = false
    }
}
